export default "__VITE_ASSET__D9aYSI4D__"